var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-set-cookies"},[_c('CircleProgressBar',{attrs:{"size":160,"process":_vm.process,"max":_vm.max}}),_c('h1',[_vm._v("Vyčkejte...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }